import {observer} from "mobx-react-lite";
import {createHashRouter, RouterProvider, useParams} from "react-router-dom";
import {Profile} from './reactjs/profilePresenter.jsx';
import { Home } from "./reactjs/homePresenter.jsx";
import { NavBar } from "./reactjs/navBarPresenter.jsx";
import { Search } from "./reactjs/searchPresenter.jsx";
import { Quiz } from "./reactjs/quizPresenter.jsx";
import { Detail } from "./reactjs/searchDetailPresenter.jsx";
import { ErrorBoundary } from "react-error-boundary";
import { Error } from "./reactjs/errorPresenter.jsx";


function makeRouter(model) {
    return createHashRouter([

        { 
            path: "/",
            errorElement: <Error/>,
            element:<Home model={model}/>,
        },
        {
            path: "/search",
            errorElement: <Error/>,
            element: <Search model={model}/>
        },
        {
            path: "/search/houses",
            errorElement: <Error/>,
            element: <Search model={model}/>
        },
        {
            path: "/search/elixirs",
            element: <Search model={model}/>
        },
        {
            path: "/search/characters",
            errorElement: <Error/>,
            element: <Search model={model}/>
        },
        {
            path: "/search/spells",
            errorElement: <Error/>,
            element: <Search model={model}/>
        },
        {
            path: "/profile",
            errorElement: <Error/>,
            element: <Profile model={model}/>
        },
        {
            path: "/quiz",
            errorElement: <Error/>,
            element: <Quiz model={model}/>
        },
        {
            path: "/detail",
            errorElement: <Error/>,
            element: <Detail model={model}/>
        }
    ])
}



const ReactRoot = observer(
    function ReactRoot(props){
        return <RouterProvider router={makeRouter(props.model)}/>
    }
)

export { ReactRoot }